export const copyToClipboard = (text: string, showNotification: () => void) => {
  // Create Fake Element to house text
  const fakeElem = document.createElement('textarea');

  // Prevent zooming on iOS
  fakeElem.style.fontSize = '12pt';

  // Reset box model
  fakeElem.style.border = '0';
  fakeElem.style.padding = '0';
  fakeElem.style.margin = '0';

  // Move element out of screen horizontally
  fakeElem.style.position = 'absolute';
  const isRTL = document.documentElement.getAttribute('dir') === 'rtl';
  fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';

  // Move element to the same position vertically
  const yPosition = window.pageYOffset || document.documentElement.scrollTop;
  fakeElem.style.top = `${yPosition}px`;

  // Allow for easier text selection
  fakeElem.setAttribute('readonly', '');

  fakeElem.value = text;

  document.body.appendChild(fakeElem);
  fakeElem.select();
  fakeElem.setSelectionRange(0, fakeElem.value.length);

  document.execCommand('copy');

  document.getSelection().removeAllRanges();
  fakeElem.remove();

  if (showNotification != null && typeof showNotification === 'function') {
    showNotification();
  }
};
